// extracted by mini-css-extract-plugin
module.exports = {"backgroundMain":"Screen_backgroundMain__29ZHV"};